import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useGlobalLoaderContext } from "contexts/GlobalLoaderContext";
import React, { useEffect, useState } from "react";
import Select from "react-select";
import { useAppDispatch, useAppSelector } from "../redux/store/configureStore";
import { getAllMstBranch } from "../redux/handlers/master/getAllMstBranch.handler";
import { useGlobalSelectedBranchContext } from "contexts/GlobalSelectedBranchContext";
import { logout } from "../redux/handlers/auth/logout.handler";
import { useNavigate } from "react-router-dom";
import { VER } from "constants/server/api";
import { SERVER_NAME } from "constants/server/config";
export function Navcustom() {
    var _useGlobalLoaderContext = useGlobalLoaderContext(), isloading = _useGlobalLoaderContext.isloading, setIsLoading = _useGlobalLoaderContext.setIsLoading;
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var _useGlobalSelectedBranchContext = useGlobalSelectedBranchContext(), selectedBranchId = _useGlobalSelectedBranchContext.selectedBranchId, setSelectedBranchId = _useGlobalSelectedBranchContext.setSelectedBranchId;
    var _useState = _sliced_to_array(useState(false), 2), isOpenAvatarMenu = _useState[0], setIsOpenAvatarMenu = _useState[1];
    var toggleAvatarDropdown = function() {
        return setIsOpenAvatarMenu(!isOpenAvatarMenu);
    };
    var loadAllMsts = function() {
        dispatch(getAllMstBranch());
    };
    var getAllMstBranchReducer = useAppSelector(function(state) {
        return state.getAllMstBranchReducer;
    });
    var _useState1 = _sliced_to_array(useState([]), 2), optionsMstBranch = _useState1[0], setOptionsMstBranch = _useState1[1];
    useEffect(function() {
        loadAllMsts();
    }, []);
    useEffect(function() {
        setIsLoading(getAllMstBranchReducer.isFetching);
        if (getAllMstBranchReducer.data) {
            setOptionsMstBranch(getAllMstBranchReducer.data.data.map(function(item) {
                return {
                    label: item.name,
                    value: item.id
                };
            }));
        }
    }, [
        getAllMstBranchReducer
    ]);
    function handleSidebar(e) {
        var sidebar = document.getElementsByClassName("app");
        for(var i = 0; i < sidebar.length; i++){
            sidebar[i].classList.toggle("sidenav-toggled");
        }
    }
    var _process_env_REACT_APP_ENV;
    return /*#__PURE__*/ _jsx("nav", {
        className: "navbar fixed-top navbar-st-1",
        children: /*#__PURE__*/ _jsxs("div", {
            className: "container-fluid",
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: "d-flex align-items-center",
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            className: "app-sidebar__toggle ms-0 me-4",
                            "data-toggle": "sidebar",
                            onClick: handleSidebar,
                            children: [
                                /*#__PURE__*/ _jsx("a", {
                                    className: "open-toggle",
                                    href: "#"
                                }),
                                /*#__PURE__*/ _jsx("a", {
                                    className: "close-toggle",
                                    href: "#"
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "d-lg-block d-none",
                            children: /*#__PURE__*/ _jsx(Select, {
                                as: "select",
                                name: "branch",
                                className: "w-100  select-st-2 branch-select",
                                options: optionsMstBranch,
                                placeholder: "เลือกสาขา",
                                onChange: function(e) {
                                    setSelectedBranchId(e.value);
                                },
                                value: optionsMstBranch.filter(function(item) {
                                    return item.value === (optionsMstBranch.length === 1 ? 1 : selectedBranchId);
                                })
                            })
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "fs-16 text-white ml-5",
                            children: [
                                "server: ",
                                (_process_env_REACT_APP_ENV = process.env.REACT_APP_ENV) !== null && _process_env_REACT_APP_ENV !== void 0 ? _process_env_REACT_APP_ENV : "-",
                                " | ",
                                SERVER_NAME,
                                " v.",
                                VER
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "d-flex align-items-center",
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            className: "dropdown nav-item main-header-message me-xl-3 me-2",
                            children: [
                                /*#__PURE__*/ _jsx("a", {
                                    className: "new nav-link",
                                    href: "#",
                                    "data-bs-toggle": "dropdown",
                                    children: /*#__PURE__*/ _jsx("div", {
                                        className: "ih-2 p-4"
                                    })
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "dropdown-menu"
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "dropdown nav-item main-header-notification me-xl-3 me-2",
                            children: [
                                /*#__PURE__*/ _jsx("a", {
                                    className: "new nav-link",
                                    href: "#",
                                    "data-bs-toggle": "dropdown",
                                    children: /*#__PURE__*/ _jsx("div", {
                                        className: "ih-1 p-4"
                                    })
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "dropdown-menu"
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "nav-item full-screen fullscreen-button me-xl-3 me-2",
                            children: /*#__PURE__*/ _jsx("a", {
                                className: "new nav-link full-screen-link",
                                href: "#",
                                children: /*#__PURE__*/ _jsx("div", {
                                    className: "ih-3 p-4"
                                })
                            })
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "dropdown gg_menu nav-item main-header-notification me-xl-3 me-2",
                            children: [
                                /*#__PURE__*/ _jsxs("a", {
                                    className: "new nav-link",
                                    href: "#",
                                    "data-bs-toggle": "dropdown",
                                    children: [
                                        " ",
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "ih-4 p-4"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "dropdown-menu"
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "dropdown me-xl-5",
                            children: [
                                /*#__PURE__*/ _jsx("a", {
                                    className: "btn  dropdown-toggle-1 drop-left ",
                                    role: "button",
                                    "data-bs-toggle": "dropdown",
                                    "aria-expanded": "false",
                                    children: /*#__PURE__*/ _jsx("div", {
                                        className: "d-flex align-items-center",
                                        children: /*#__PURE__*/ _jsx("img", {
                                            src: "/images/Avatar.png",
                                            className: "Avatar"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ _jsx("ul", {
                                    className: "dropdown-menu",
                                    children: /*#__PURE__*/ _jsx("li", {
                                        children: /*#__PURE__*/ _jsx("button", {
                                            className: "dropdown-item text-color-6 fs-14 spacing-1 ms-2",
                                            onClick: function() {
                                                return logout(navigate, "/login");
                                            },
                                            children: "ออกจากระบบ"
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
